import { useContext } from 'react';

import { DeviceContext } from '../contexts';

/**
 * Hook used to consume information about device
 * @returns {DeviceInfo} Information about device
 */
export const useDeviceInfo = () => {
  const deviceInfo = useContext(DeviceContext);
  return deviceInfo;
};
